import imgRegioes from '../../../../../assets/images/empresa/sobre-nos/mapa_sem_ceara.png';
import DefaultText from "../../../../../components/typography/default-text";
import { getRegioes } from "./listRegioes";
import styles from "./styles.module.css";


const Unidades: React.FC = () => {

  const listRegioes = getRegioes();

  return (
    <div className={styles["sub-page-content"]}>
      <div className={styles["regioes-banner-container"]}>
        <img src={imgRegioes} alt={'Imagem do mapa do Brasil destacando todas as regiões em que a TELEMONT está presente'} className={styles["banner-image"]} />
        <div className={styles["banner-text-content"]} style={{ gap: "48px" }}>
          <div className={styles["banner-text-content"]}>
            <div>
              <DefaultText size="medium" sx={{ fontFamily: 'Montserrat-Regular' }}>TELEMONT</DefaultText>
              <DefaultText size="medium" sx={{ fontFamily: 'Montserrat-Bold' }}><i>sempre presente</i></DefaultText>
            </div>
            <DefaultText size="small">
              Nossas soluções estão presentes em 10 estados e no
              Distrito Federal.
            </DefaultText>
          </div>
          <div className={styles["banner-text-content"]}>
            <DefaultText size="medium" sx={{ fontFamily: 'Montserrat-Bold' }}><i>MATRIZ</i></DefaultText>
            <DefaultText size="small">
              Rua Santa Fé, 100 <br />
              Bairro Sion, Belo Horizonte - MG, 30320-130 <br /> <br />
              Telefone: (31)3448-8700
            </DefaultText>
          </div>
        </div>
      </div>
      <div className={styles["regions-grid"]}>
        {listRegioes.map((regiao, index) => (
          <div className={styles["region-card"]} key={index}>
            <DefaultText sx={{ fontFamily: 'Montserrat-Bold', fontsize: '25px' }}>{regiao.title}</DefaultText>
            <DefaultText size="small" sx={{ color: 'var(--secondary-dark-grey)'}}>{regiao.description}</DefaultText>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Unidades;